export enum HomeScreenView {
  dashboard = "dashboard",
  feed = "feed",
}
